import React, { ReactNode } from "react";
import {
  ButtonBlock,
  HeroSliderBlock,
  ColumnsBlock,
  DividerBlock,
  HeadingBlock,
  HtmlBlock,
  ImageBlock,
  SocialsBlock,
  TextBlock,
  VideoBlock,
} from "./content-blocks";

import { IDesignBlock } from "../../../types/iblock";

import {
  IButtonBlockData,
  IHeroSliderBlockData,
  IColumnsBlockData,
  IHeadingBlockData,
  IHtmlBlockData,
  IImageBlockData,
  ISocialsBlockData,
  ITextBlockData,
  IVideoBlockData,
} from "../../../types/content-block-data";
import blocksManager from "../../../stores/blocks-manager";

export function renderContentBlock(block: IDesignBlock): ReactNode {
  switch (block.contentBlock.blockType) {
    case "heading":
      return (
        <HeadingBlock
          {...(block.contentBlock.blockData as IHeadingBlockData)}
          contentBlockRef={undefined}
          isEditing={false}
        />
      );
    case "text":
      return (
        <TextBlock
          {...(block.contentBlock.blockData as ITextBlockData)}
          contentBlockRef={undefined}
          isEditing={false}
        />
      );
    case "button":
      const buttonData = block.contentBlock.blockData as IButtonBlockData;
      return (
        <ButtonBlock
          // Spread all other props from IColumnsBlockData
          {...buttonData}
          contentBlockRef={undefined}
        />
      );
    case "divider":
      return <DividerBlock contentBlockRef={undefined} />;
    case "image":
      return (
        <ImageBlock
          {...(block.contentBlock.blockData as IImageBlockData)}
          contentBlockRef={undefined}
        />
      );
    case "hero_slider":
      return (
        <HeroSliderBlock
          selectedIndex={blocksManager.getHeroSlideEditing().selectedSlideIndex!}
          {...(block.contentBlock.blockData as IHeroSliderBlockData)}
          contentBlockRef={undefined}
        />
      );
    case "columns":
      const data = block.contentBlock.blockData as IColumnsBlockData;
      
      // Ensure children is an array of arrays of IDesignBlock
      const children: IDesignBlock[][] = data.children ?? [];
      
      return (
        <ColumnsBlock
          // Spread all other props from IColumnsBlockData
          {...data}
          colContentBlockId={block.contentBlock.contentBlockId}
          // Pass correct children and required renderBlock function
          children={children}
          renderBlock={renderContentBlock}
          className="w-full"
        />
      );
    case "video":                                
      return (
        <VideoBlock
          {...(block.contentBlock.blockData as IVideoBlockData)}
          contentBlockRef={undefined}
        />
      );
    case "socials":
      return (
        <SocialsBlock
          {...(block.contentBlock.blockData as ISocialsBlockData)}
          contentBlockRef={undefined}
        />
      );
    case "html":
      return (
        <HtmlBlock
          {...(block.contentBlock.blockData as IHtmlBlockData)}
          contentBlockRef={undefined}
        />
      );
    default:
      return (
        <div className="p-2 border text-red-500">
          Unknown block type: {block.contentBlock.blockType}
        </div>
      );
  }
}